// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1_LcG","rightAdornment":"Header_rightAdornment__QI9BP"};